import { TypographyProps } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { ReactNode } from "react";
import Text from "./Text";

type TextProps = {
  children: ReactNode;
  variant?: Variant | "inherit";
} & TypographyProps;

/**
 *  Component use to handle the form title for every section
 * support loose coupling  & easy scalability
 * @author rajkumar rathod
 */
const FormHeadChip = ({ variant, children, ...others }: TextProps) => {
  return (
    <Text
      variant={variant ?? "h4"}
      fontWeight={others?.fontWeight ?? "medium"}
      textTransform={others?.textTransform ?? "none"}
      {...others}
    >
      {children}
    </Text>
  );
};

export default FormHeadChip;
